import * as React from 'react'
import { Button, Grid, MenuItem, IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useCallback, useEffect, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import { useTheme } from '@mui/material/styles'
import {
  StyledGridContainer,
  StyledLabel,
  StyledSelect,
  StyledSelectContainer,
  StyledTextField,
  StyledText,
} from './components'

export const ContractFilterHeader = React.memo(
  ({
    searchText,
    onSearchTextChanged,
    contractTypeFilter,
    onContractTypeFilterChanged,
    contractStatusFilter,
    onContractStatusFilterChanged,
    onResetFiltersPressed,
  }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const [localSearchText, setLocalSearchText] = useState(searchText)

    useEffect(() => {
      setLocalSearchText(searchText)
    }, [searchText])

    useEffect(() => {
      const timer = setTimeout(() => {
        if (localSearchText !== searchText) {
          onSearchTextChanged(localSearchText)
        }
      }, 300)

      return () => clearTimeout(timer)
    }, [localSearchText, searchText, onSearchTextChanged])

    const handleContractTypeFilterChange = useCallback(
      (event) => {
        onContractTypeFilterChanged(event.target.value)
      },
      [onContractTypeFilterChanged]
    )

    const handleContractStatusFilterChange = useCallback(
      (event) => {
        onContractStatusFilterChanged(event.target.value)
      },
      [onContractStatusFilterChanged]
    )

    const handleSearchTextChange = useCallback((event) => {
      setLocalSearchText(event.target.value)
    }, [])

    return (
      <StyledGridContainer container rowSpacing={1}>
        <Grid
          item
          xs={12}
          md={6}
          style={{ display: 'flex', alignItems: 'flex-end' }}
        >
          <StyledTextField
            placeholder={t('LBLSearch')}
            value={localSearchText}
            onChange={handleSearchTextChange}
            variant="standard"
            margin="none"
            InputProps={{
              style: { width: '100%' },
              disableUnderline: true,
              endAdornment: (
                <IconButton size="small" edge={false} sx={{ p: 0, pr: 5 }}>
                  <SearchIcon sx={{ color: theme.tokens.primary }} />
                </IconButton>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          {/* Contract type filter */}
          <StyledSelectContainer>
            <StyledLabel variant="h6">{t('LBLContractType')}</StyledLabel>
            <StyledSelect
              value={contractTypeFilter}
              onChange={handleContractTypeFilterChange}
              displayEmpty
              variant="outlined"
            >
              <MenuItem value="">{t('LBLAll')}</MenuItem>
              <MenuItem value="PRODUCER">{t('LBLProducer')}</MenuItem>
              <MenuItem value="CONSUMER">{t('LBLConsumer')}</MenuItem>
            </StyledSelect>
          </StyledSelectContainer>
        </Grid>
        <Grid item xs={12} md={2}>
          {/* Contract status filter */}
          <StyledSelectContainer>
            <StyledLabel variant="h6">{t('LBLcontractStatus')}</StyledLabel>
            <StyledSelect
              value={contractStatusFilter}
              onChange={handleContractStatusFilterChange}
              displayEmpty
              variant="outlined"
            >
              <MenuItem value="">{t('LBLAll')}</MenuItem>
              <MenuItem value="ACTIVE">{t('LBLActive')}</MenuItem>
              <MenuItem value="INACTIVE">{t('LBLInactive')}</MenuItem>
              <MenuItem value="IN_PROGRESS">{t('LBLInreview')}</MenuItem>
            </StyledSelect>
          </StyledSelectContainer>
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
          style={{
            alignItems: 'end',
            justifyContent: 'flex-end',
            display: 'flex',
          }}
        >
          <Button onClick={onResetFiltersPressed}>
            <StyledText variant="h5" align="left">
              {t('LBLResetFilters')}
            </StyledText>
          </Button>
        </Grid>
      </StyledGridContainer>
    )
  }
)

ContractFilterHeader.displayName = 'ContractFilterHeader'
